// extracted by mini-css-extract-plugin
export default {"pageTitle":"Cashup_pageTitle__zTePi","sticky":"Cashup_sticky__KWm3Z"};